import React, { PureComponent } from 'react';
import convert from 'convert-units';

import './DistanceInput.scss';

class DistanceInput extends PureComponent {
	constructor(props) {
		super(props);
		const precision = Math.pow(10, this.props.precision || 2);
		this.state = {
			units: this.props.displayUnits,
			value: Math.round(convert(this.props.value).from(this.props.baseUnits).to(this.props.displayUnits) * precision)/precision,
		}
		this.onChange = this.onChange.bind(this);
	}
	
	massage(value) {
		return convert(value).from(this.props.baseUnits).to(this.state.units);
	}
	
	onChange(e) {
		if (e.target.name === 'value') {
			const out = e.target.value;
			this.setState({[e.target.name]: out}, ()=>{
				if (this.props.onChange)
					this.props.onChange({target: {name: this.props.name, value: convert(out).from(this.state.units).to(this.props.baseUnits)}});
			});
		} else {
			this.setState({[e.target.name]: [e.target.value]});
		}
	}
	
	
	render() {
		return (
			<div className={(this.props.className || '') + ' distance-input'}>
				<input type="text" name="value" value={this.state.value} onChange={this.onChange} placeholder={this.props.placeholder} />
				<select name="units" value={this.state.units} onChange={this.onChange}>
					<option value="cm">cm</option>
					<option value="in">Inches</option>
					<option value="ft-us">Feet</option>
				</select>
			</div>
		);
	}
}

export default DistanceInput;
